module.exports = __webpack_public_path__ + "img/coreFun_bg1.defd4307.png";